( function( $ ) {
	const getSectionDistance = $section => {
		const adminPanel = $( '#wpadminbar' );
		let adminBar = 0;

		if ( adminPanel.length )
		{adminBar = adminPanel.outerHeight();}

		const headerHeight = $( '.page-header' ).outerHeight() + adminBar;
		const hashSectionPosition = $section.find( '.section__body' )[0].getBoundingClientRect();
		return hashSectionPosition.top + $( '.wp-site-blocks' )[0].scrollTop - headerHeight;
	};

	let initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-services' );
		const $page = $( '.wp-site-blocks' );

		$section.each( function() {
			window.app.main.customScrollbarsForSection( this );
			window.app.main.horizontalScroll( this );
			const $sectionInstance = $( this );

			const sectionStyleV1 = () => {
				if ( $sectionInstance.hasClass( 'section-services--style-v1' ) ) {
					setTimeout( function() {
						const $sectionServicesNav = $sectionInstance.find( '.section-services__nav' );
						const $sectionServicesTab = $sectionServicesNav.find( '.section-services__tab' );
						const $scrollContent = $sectionServicesNav.find( '.scroll-content' );

						if ( !$.fn.hScroll ) {
							window.app.main.horizontalScroll();
						}

						if ( $scrollContent.length ) { // if custom scrollbar was initialized
							$scrollContent.hScroll( 60 );
						} else { // if there's no custom scrollbar
							$sectionServicesTab.hScroll( 60 );
						}

						$sectionServicesNav.find( '.nav-link' ).off().on( 'click', function() {
							const $link = $( this );
							const isDesktop = window.matchMedia( '(min-width: 768px)' ).matches;

							if ( !isDesktop ) {
								$page.css( 'overflow', 'hidden' );
							}

							$page.animate(
								{ scrollTop: isDesktop ? $( '.wp-site-blocks' )[0].scrollTop : getSectionDistance( $sectionInstance ) },
								( isDesktop ? 200 : 500 ),
								() => setTimeout( () => $page.removeAttr( 'style' ), ( isDesktop ? 0 : 400 ) )
							);

							if ( $scrollContent.length ) {
								const navItemsRect = $scrollContent[0].getBoundingClientRect();
								const navItemActiveRect = $link[0].getBoundingClientRect();
								const navItemsLeft = $scrollContent.scrollLeft() + navItemActiveRect.left - navItemsRect.left + ( navItemActiveRect.width - navItemsRect.width ) / 2;
								$scrollContent.animate( { scrollLeft: navItemsLeft }, 600, 'swing' );
							} else {
								const navItemsRect = $sectionServicesTab[0].getBoundingClientRect();
								const navItemActiveRect = $link[0].getBoundingClientRect();
								const navItemsLeft = $sectionServicesTab.scrollLeft() + navItemActiveRect.left - navItemsRect.left + ( navItemActiveRect.width - navItemsRect.width ) / 2;
								$sectionServicesTab.animate( { scrollLeft: navItemsLeft }, 600, 'swing' );
							}
						} );

						$sectionServicesNav.find( '.nav-link' ).on( 'shown.bs.tab', function() {
							$sectionInstance[0].scrollIntoView( {block: 'end'} );
						} );
					}, 1000 );
				}
			};

			const sectionStyleV2 = () => {
				if ( $sectionInstance.hasClass( 'section-services--style-v2' ) ) {
					const $accordionItem = $sectionInstance.find( '.js-service-accordeon-item' );
					const $serviceSpine = $accordionItem.find( '.service__spine' );
					const $serviceInfo = $accordionItem.find( '.service__info' );

					let slideAnimationY;
					let slideAnimationX;

					if (
						window.matchMedia( 'screen and (min-width: 1280px)' ).matches &&
						$section.find( '.accordeon' ).hasClass( 'accordeon--horizontal' )
					) {
						slideAnimationX = true;
						slideAnimationY = false;
					} else {
						slideAnimationX = false;
						slideAnimationY = true;
					}

					$serviceSpine.each( function() {
						const $serviceSpineInstance = $( this );

						if ( slideAnimationY ) {
							$serviceSpineInstance.off( 'click' ).on( 'click', function() {
								if ( !$serviceSpineInstance.hasClass( 'active' ) ) {
									$serviceSpine.addClass( 'disable' );

									$serviceSpine.removeClass( 'active' );

									$serviceInfo
										.find( '.service__index-bg' )
										.removeClass( 'active' );

									$serviceInfo
										.removeClass( 'active' )
										.slideUp()
										.find( '.service__body' )
										.removeClass( 'active' );

									$serviceSpineInstance
										.addClass( 'active' )
										.siblings( '.service__info' )
										.addClass( 'active' )
										.slideDown( function() {
											$( this ).find( '.service__body, .service__index-bg' )
												.addClass( 'active' );
										} );

									setTimeout( ()=> {
										$serviceSpine.removeClass( 'disable' );
									}, 500 );
								}
							} );
						} else if ( slideAnimationX ) {
							$serviceSpineInstance.off( 'click' ).on( 'click', function() {
								if ( !$serviceSpineInstance.hasClass( 'active' ) ) {
									$serviceSpine.addClass( 'disable' );

									$serviceSpine.removeClass( 'active' );

									$serviceInfo
										.find( '.service__body' )
										.removeClass( 'active' );

									$serviceInfo
										.find( '.service__index-bg' )
										.removeClass( 'active' );

									$serviceInfo
										.filter( '.active' )
										.toggle( 'slide' )
										.removeClass( 'active' );

									$serviceSpineInstance
										.addClass( 'active' )
										.siblings( '.service__info' )
										.css( 'min-height', '100%' )
										.addClass( 'active' )
										.toggle( 'slide', function() {
											$( this ).find( '.service__body, .service__index-bg' )
												.addClass( 'active' );
										} );

									setTimeout( ()=> {
										$serviceSpine.removeClass( 'disable' );
									}, 500 );
								}
							} );
						}
					} );
				}
			};

			const sectionStyleV4 = () => {
				if ( $sectionInstance.hasClass( 'section-services--style-v4' ) ) {
					const $slider = $sectionInstance.find( '.js-services-slider' );
					const $thumbs = $sectionInstance.find( '.js-thumbs-slider' );

					$sectionInstance.find( '.swiper-button-lock' ).removeClass( 'swiper-button-lock' );

					if ( !$slider[0] || !$thumbs[0] ) {
						return;
					}

					if ( $slider[0]?.swiper ) {
						$slider[0]?.swiper.destroy( true, true );
					}

					if ( $thumbs[0]?.swiper ) {
						$thumbs[0]?.swiper.destroy( true, true );
					}

					let direction = 'horizontal';
					let grid = null;


					let slidesPerView = 2;
					let slidesPerGroup = 2;

					const handleSliderSettings = () => {
						if ( window.matchMedia( 'screen and (min-width: 768px)' ).matches ) {
							slidesPerView = 4;
							slidesPerGroup = 4;
						}

						if ( window.matchMedia( 'screen and (min-width: 1280px)' ).matches ) {
							direction = 'vertical';

							grid = {
								fill: 'column',
								rows: 2
							};
						}
					};

					handleSliderSettings();

					const swiperThumbs = new Swiper( $thumbs[0], {
						speed: 1000,
						slidesPerView,
						slidesPerGroup,
						spaceBetween: 0,
						noSwiping: true,
						direction,
						grid,
						rewind: true,
						slideToClickedSlide: true,
						navigation: {
							nextEl: $sectionInstance.find( '.swiper-button-next' )[0],
							prevEl: $sectionInstance.find( '.swiper-button-prev' )[0],
						},

						pagination: {
							el: $sectionInstance.find( '.section-services__thumbs-bullets' )[0],
							type: 'bullets',
							bulletClass: 'section-services__thumbs-bullet',
							bulletActiveClass: 'section-services__thumbs-bullet--active',
							bulletElement: 'div',
							clickable: true,
						},
					} );

					let $bgWrapper = $sectionInstance.find( '.background-img' );

					const runBgChange = ( swiperInstance ) => {
						if ( !swiperInstance ) {
							throw new Error( 'Wrong swiper instance' );
						}
						if ( !swiperInstance.el.classList.contains( 'bg-affect' ) )
						{return;}

						const index = swiperInstance.realIndex;
						const slide = swiperInstance.slides[index];
						const item = slide.querySelector( '[data-bg-image]' );
						const bgURL = item.dataset.bgImage;
						const poster = item.dataset.poster;
						return changeSectionBg( bgURL, poster );
					};

					const swiperServices = new Swiper( $slider[0] ,{
						speed: 1000,
						effect: 'fade',
						simulateTouch: false,
						fadeEffect: {
							crossFade: true,
						},
						thumbs: {
							swiper: swiperThumbs
						},
						on: {
							afterInit: runBgChange
						}
					} );

					swiperServices.on( 'slideChange', function( swiperInstance ) {
						runBgChange( swiperInstance );
					} );

					function changeSectionBg( source, posterURL = null ) {
						let mediaElement;
						let type = null;

						const prepareMediaElement = () => {
							const fileExtension = source.split( '.' ).pop().toLowerCase();
							const videoExtensions = ['mp4', 'avi', 'mov', 'wmv'];
							const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];

							if ( imageExtensions.includes( fileExtension ) ) {
								mediaElement = document.createElement( 'img' );
								type = 'image';
							} else if ( videoExtensions.includes( fileExtension ) ) {
								mediaElement = document.createElement( 'video' );
								mediaElement.muted = true;
								mediaElement.autoplay = true;
								mediaElement.loop = true;
								mediaElement.setAttribute( 'muted', 'true' );
								mediaElement.setAttribute( 'playsinline', 'playsinline' );
								if ( posterURL ) {
									mediaElement.setAttribute( 'poster', posterURL );
								}
								type = 'video';
							}
							mediaElement.setAttribute( 'src', source );
						};


						if ( typeof source === 'string' && isValidURL( source ) ) {
							prepareMediaElement();
						} else if (
							source instanceof HTMLImageElement ||
							source instanceof HTMLPictureElement ||
							source instanceof HTMLVideoElement
						) {
							mediaElement = source;
							type = source instanceof HTMLVideoElement ? 'video' : 'image';
						} else {
							throw new Error( 'Parameter is not a valid URL string or HTML img/picture element' );
						}
						const imageWrapper = $( '<div class="background-img"></div>' );
						imageWrapper.append( mediaElement );
						$bgWrapper.prevAll( '.background-img' ).remove();
						$( imageWrapper ).insertBefore( $bgWrapper );
						$bgWrapper.animate( { opacity: 0 }, function() {
							$( this ).remove();
							$( this ).nextAll( 'background-img' ).remove();
						} );
						$bgWrapper = imageWrapper;
						return {
							type,
							el: mediaElement
						};
					}

					function isValidURL( source ) {
						const regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}(\.[a-zA-Z0-9()]{1,6})?\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
						return regex.test( source );
					}
				}
			};

			const sectionStyleV5 = () => {
				if ( $sectionInstance.hasClass( 'section-services--style-v5' ) ) {
					$sectionInstance.find( '.js-services-slider' ).each( function() {
						let $slider = $( this );

						if ( this.swiper ) {
							this.swiper.destroy( true, true );
						}

						const swiperSlideLength = $slider.find( '.swiper-slide' ).length;

						let loop = false;
						let rewind = true;

						const handleSliderSettings = () => {
							if (
								swiperSlideLength > 3 && window.matchMedia( 'screen and (min-width: 1025px)' ).matches ||
								swiperSlideLength > 4 && window.matchMedia( 'screen and (min-width: 2000px)' ).matches ||
								swiperSlideLength > 2 && window.matchMedia( 'screen and (max-width: 1024.5px)' ).matches
							) {
								loop = true;
								rewind = false;
							}
						};

						handleSliderSettings();

						new Swiper( $slider[0], {
							slidesPerView: 'auto',
							speed: 1000,
							spaceBetween: 8,
							rewind,
							loop,
							loopedSlides: 15,
							loopAdditionalSlides: 10,
							slideToClickedSlide: false,
							simulateTouch: false,
							a11y: {
								enabled: false
							},
							navigation: {
								nextEl: $slider.find( '.swiper-button-next' )[0],
								prevEl: $slider.find( '.swiper-button-prev' )[0],
							},
							breakpoints: {
								768: {
									spaceBetween: 12,
								},
								1280: {
									spaceBetween: 24,
								},
								1720: {
									spaceBetween: 30,
								}
							}
						} );

						if (
							$slider.find( '.swiper-button-prev' ).hasClass( 'swiper-button-lock' ) &&
							$slider.find( '.swiper-button-next' ).hasClass( 'swiper-button-lock' )
						) {
							$slider.find( '.swiper-controls' ).addClass( 'd-none' );
						} else {
							$slider.find( '.swiper-controls' ).removeClass( 'd-none' );
						}
					} );
				}
			};

			const loadSliders = () => {
				sectionStyleV1();
				sectionStyleV2();
				sectionStyleV4();
				sectionStyleV5();
			};

			window.app.loadVendor( 'Swiper', loadSliders );
		} );
	};

	window.app.loadBlock( initBlock, 'section-services', '.section-services' );
} )( jQuery );
